import { createApp } from 'vue';
import App from '@/presentation/App.vue';
import pluginLoader from '@/presentation/libs/plugin-loader.lib';
import { clickOutside } from '@/presentation/directives/clickOutside.directive';

const app = createApp(App);
app.use(pluginLoader);
app.directive('click-outside', clickOutside);
